// Обновленный CabinetChildrenCard.js с использованием API
import React, { useState, useEffect } from 'react';
import { Card, Table, Nav, Button, Badge, Collapse } from 'react-bootstrap';
import { childrenApi } from './api/childrenApi';
import { downloadFile } from '../../../../services/apiClient';
import './CabinetChildrenCard.css';
import { statuses_types, state_child } from './data/statuses'
import { childTabDataService } from '../../../kindergartens/detail/components/ChildrenCard/actions/childApiService';

import expand_icon_up from '../../../../img/arrow-up-fill.svg';
import expand_icon_down from '../../../../img/arrow-down-fill.svg';


const getPlaceTypeName = (placeType) => {
  const typeMap = {
    'standart': 'Повного дня',
    'without-bed': 'Короткотривале',
    'inclusive': 'Інклюзивне',
    'inclusive-short': 'Інклюзивне короткотривале'
  };
  return typeMap[placeType] || placeType;
};


const prepareStatusesData = (statusesList = [], kgList = [], initialKg = {}, initialGr = {}) => {
  let lastKnownKg = { ...initialKg };
  let lastKnownGr = { ...initialGr };

  // Хронологічне сортування (від найстаріших до найновіших)
  const sortedStatuses = [...statusesList].sort(
    (a, b) => new Date(a.statusInsertDate) - new Date(b.statusInsertDate)
  );

  const enrichedStatuses = sortedStatuses.map((status) => {
    const { kindergartenId, groupNumber, placeType, currentKindergartenDistrict } = status;

    if (kindergartenId) {
      const foundKg = kgList.find(item => item._id === kindergartenId);
      if (foundKg) lastKnownKg = foundKg;
    }

    if (groupNumber || placeType) {
      lastKnownGr = {
        number: groupNumber || lastKnownGr.number || '',
        type: placeType || lastKnownGr.type || ''
      };
    }

    return {
      ...status,
      kgNumber: lastKnownKg?.number || lastKnownKg?.name || '', 
      kgDistrict: currentKindergartenDistrict || lastKnownKg?.contacts?.address?.district || '',
      grNumber: groupNumber || lastKnownGr.number || '',
      grType: placeType || lastKnownGr.type || ''
    };
  });

  // Поточний (найновіший) стан — це останній елемент після сортування
  // Якщо масив порожній, повертаємо початкові значення зі стейту
  const currentStatusInfo = enrichedStatuses[enrichedStatuses.length - 1];

  const currentInfo = {
    kindergarten: currentStatusInfo ? {
      _id: currentStatusInfo.kindergartenId,
      number: currentStatusInfo.kgNumber,
      district: currentStatusInfo.kgDistrict,
      // Тут також будуть інші оригінальні поля садка з масиву kg, якщо він був знайдений
      ...kgList.find(item => item._id === currentStatusInfo.kindergartenId)
    } : lastKnownKg,
    
    group: currentStatusInfo ? {
      number: currentStatusInfo.grNumber,
      type: currentStatusInfo.grType
    } : lastKnownGr
  };

  return {
    enrichedStatuses, // Масив для таблиці
    currentInfo       // Об'єкт з поточним садком та групою
  };
};




const CabinetChildrenCard = ({ data }) => {
  const [activeTab, setActiveTab] = useState('history');
  const [kgDetailsExpanded, setKgDetailsExpanded] = useState(false);
  const [programs, setPrograms] = useState([]);
  const [attendsInfo, setAttendsInfo] = useState([]);
  const [billingInfo, setBillingInfo] = useState([]);
  const [historyInfo, setHistoryInfo] = useState([]);
  const [paymentsInfo, setPaymentsInfo] = useState([]);
  const [loading, setLoading] = useState(false);

  const { child, kg, isInKindergarten } = data;
  const { _id, firstName, lastName, birthDate, birthCertificate } = child;

  const { enrichedStatuses, currentInfo} = prepareStatusesData(child.statuses, kg);


  const [currentKg, setCurrentKg] = useState(currentInfo.kindergarten || {});
  const [currentGr, setCurrentGr] = useState(kg[0] && kg[0].groups);
  //const currentKg = kg[0]; // Берем первый садик (текущий)

  useEffect(() => {
    if (currentKg) {
      loadAdditionalData();
    }
  }, [currentKg]);

  const loadAdditionalData = async () => {
    if (!currentKg) return;
    
    setLoading(true);
    try {
      const [programsData, attendsData, billingData, paymentsData, historyData] = await Promise.all([
        childrenApi.getKindergartenPrograms(currentKg._id),
        childrenApi.getAttendsInfo(_id),
        childrenApi.getBillingInfo(_id, currentKg._id),
        childrenApi.getPaymentsInfo(_id, currentKg._id),
        loadHistoryData(_id)
      ]);

      

      setPrograms(programsData);
      setAttendsInfo(attendsData);
      setBillingInfo(billingData);
      setPaymentsInfo(paymentsData);
      setHistoryInfo(historyData);

    } catch (error) {
      console.error('Error loading additional data:', error);
    } finally {
      setLoading(false);
    }
  };


   // Загрузка данных истории
    const loadHistoryData = async (childId) => {
      try {
        const result = await childTabDataService.getChildHistory(childId);
        if (result && result.length > 0) {
          return result;
        }
        return [];
      } catch (error) {
        console.error('Error loading history data:', error);
        return [];
      }
    };

  const getStatusBadge = () => !isInKindergarten ? <Badge className="status-expelled">Дитина відрахована</Badge>
    : <Badge className="status-selected">В садочку</Badge>;

  const getGroupInfo = () => {
    if (!currentKg || !currentKg.groups) return '';
    const group = currentKg.groups;
    return `Група ${group.number} ${group.name}, ${group.type}`;
  };

  const handleDownloadInvoice = async () => {
    if (!currentKg) return;
    
    try {
      await childrenApi.downloadInvoice(_id, currentKg._id);
    } catch (error) {
      alert(error.message);
    }
  };

  const handleDownloadProgram = async (programId, fileId, fileName) => {
    try {
      const url = `docfile?doc_id=${programId}&file_id=${fileId}`;
      await downloadFile(url, fileName);
    } catch (error) {
      console.error('Error downloading program file:', error);
      alert('Помилка при завантаженні файлу');
    }
  };

  const formatFileSize = (bytes) => {
    if (!bytes) return '0 Bytes';
    const k = 1024;
    const sizes = ['Bytes', 'KB', 'MB', 'GB'];
    const i = Math.floor(Math.log(bytes) / Math.log(k));
    return parseFloat((bytes / Math.pow(k, i)).toFixed(2)) + ' ' + sizes[i];
  };

  const renderTabContent = () => {
    if (loading) {
      return <div className="tab-loading">Завантаження...</div>;
    }

    switch (activeTab) {
      case 'history':
        return renderHistoryTable();
      case 'billing':
        return renderBillingTable(billingInfo);
      case 'attendance':
        return renderAttendanceTable(attendsInfo);
      case 'payments':
        return renderPaymentsTable(paymentsInfo);
      default:
        return renderHistoryTable();
    }
  };

const renderHistoryTable = (data = []) => {
  
  const currentKindergarten = currentInfo.kindergarten;
  const currentGroup = currentInfo.group;

  return (
    <div>
      {/* Приклад відображення плашки з поточним садком над таблицею */}
      {false && <div className="current-kindergarten-panel">
        <h3>Поточне місце навчання:</h3>
        <p><strong>Садок:</strong> №{currentKindergarten.number || 'Не вказано'}</p>
        <p><strong>Район:</strong> {currentKindergarten.district || 'Не вказано'}</p>
        <p><strong>Група:</strong> {currentGroup.number} ({currentGroup.type})</p>
      </div>}

      {/* Ваша таблиця історії */}
      <Table responsive>
        <thead>
          <tr>
            <th>№</th>
            <th>Дата</th>
            <th>Подія</th>
            <th>Сад</th>
            <th>Група</th>
          </tr>
        </thead>
        <tbody>
          {enrichedStatuses.map((status, index) => {
            const st_translate = status.action
              ? (statuses_types.find(st => st.action === status.action)?.translate || status.action)
              : (state_child[status.state] || status.state);

            return (
              <tr key={status._id || index}>
                <td>{index + 1}</td>
                <td>{status.statusInsertDate ? new Date(status.statusInsertDate).toLocaleDateString('uk-UA') : ''}</td>
                <td>{st_translate}</td>
                <td>№ {status.kgNumber}</td>
                <td>{status.grNumber}</td>
              </tr>
            );
          })}
        </tbody>
      </Table>
    </div>
  );
}



const getDates = (date) => {

  const [year, month, day] = date.split("T")[0].split("-");

  return `${day}.${month}`;

}


  const renderBillingTable = (data=[]) => (
    <Table responsive>
      <thead>
          <tr>
            <th>Садочок</th>
            <th>Група</th>
            <th>Табельний номер</th>
            <th>Тариф</th>
            <th>Нараховано</th>
            <th>До оплати</th>
          </tr>
        </thead>
        <tbody>
          {data.map((bill, index) => (
            <tr key={index}>
              <td>{bill.kg_number}</td>
              <td>{bill.group}</td>
              <td>{bill.tab}</td>
              <td>{bill.tarif}</td>
              <td>{bill.charged}</td>
              <td>{bill.to_payd}</td>
            </tr>
          ))}
        </tbody>
    </Table>
  );

  const renderAttendanceTable = (data=[]) => (
    <Table responsive>
      <thead>
          <tr>
            <th>Садочок</th>
            <th>Група</th>
            <th>Кількість днів</th>
            <th>Дати</th>
          </tr>
        </thead>
        <tbody>
          {data.map((attend, index) => (
            <tr key={index}>
              <td>{attend.kg.number} {attend.kg.name}</td>
              <td>{attend.gr.number} {attend.gr.name}</td>
              <td>{attend.dates.length}</td>
              <td>{attend.dates.map(d=>`${d.split('-')[2].split('T')[0]}.${d.split('-')[1]}`).join(", ") }</td>
            </tr>
          ))}
        </tbody>
    </Table>
  );

  const renderPaymentsTable = (data=[]) => (
    <Table responsive>
      <thead>
            <tr>
              <th>Номер</th>
              <th>Дата</th>
              <th>Сума</th>
            </tr>
          </thead>
          <tbody>
            {data.length > 0 ? (
              data.map((payment, index) => (
                <tr key={index}>
                  <td>{index + 1}</td>
                  <td>{payment.date_pay	? new Date(payment.date_pay).toLocaleDateString('uk-UA') : '-'}</td>
                  <td>{payment.summ && +payment.summ.replace(/\$/g, '').replace(/\,/g, '') || 0} грн.</td>
                </tr>
              ))
            ) : (
              <tr>
                <td colSpan="5" className="text-center py-4">
                  Немає даних про оплати
                </td>
              </tr>
            )}
          </tbody>
    </Table>
  );

  if (!currentKg) {
    return (
      <Card className="application-card">
        <div className="card-header">
          <div className="applicant-info">
            <h3 className="applicant-name">{firstName}</h3>
            <Badge className="status-expelled">Немає даних про садочок</Badge>
          </div>
        </div>
      </Card>
    );
  }

  return (
    <Card className="application-card">
      <div className="card-header">
        <div className="applicant-info">
          <h3 className="applicant-name">{firstName}</h3>
          {getStatusBadge()}
        </div>
        {false && <div className="application-meta">
          <a href="#" className="regulate-btn">Редагувати</a>
        </div>}
      </div>

      <Card.Body>
        {/* Детали садика - раскрывающаяся секция */}
        <div className="birth-certificate-wrapper">
          <div className="birth-certificate">
            <div 
              className="certificate-info"
              onClick={() => setKgDetailsExpanded(!kgDetailsExpanded)}
              style={{ cursor: 'pointer' }}
            >
              <div className="children certificate-details">
                <span className="certificate-text">Заклад дошкільної освіти {currentKg.number} </span>
                <span className="certificate-date">{getGroupInfo()}</span>
              </div>
              <img 
                src={kgDetailsExpanded ? expand_icon_up : expand_icon_down} 
                alt="expand" 
                className="expand-icon" 
              />
            </div>
          </div>
        </div>

        <Collapse in={kgDetailsExpanded}>
          <div className="kg-details-expanded">
            {/* Основная информация о садике */}
            <div className="kg-basic-info">
              <div><strong>Назва:</strong> {currentKg.name}</div>
              <div><strong>Адреса:</strong> {currentKg.contacts?.address?.string}</div>
              <div><strong>Група:</strong> {getGroupInfo()}</div>
              {currentKg.groups?.children?.placeType && (
                <div><strong>Тип місця:</strong> {currentKg.groups.children.placeType}</div>
              )}
              {currentKg.groups?.children?.typeKitchen === 'diet' && (
                <div><strong>Дієтичне харчування</strong></div>
              )}
              {currentKg.groups?.specifics && (
                <div><strong>Тип групи:</strong> {currentKg.groups.specifics}</div>
              )}
              {currentKg.groups?.educators && currentKg.groups.educators.length > 0 && (
                <div><strong>Вихователі:</strong> {currentKg.groups.educators.map(el => el.firstName).join(', ')}</div>
              )}
            </div>

            {/* Контакты садика */}
            <div className="kg-contacts-section">
              <h5>Контакти садочка</h5>
              <div className="kg-contacts">
                {currentKg.contacts?.phones && <div><strong>Телефон:</strong> {currentKg.contacts.phones.join(", ")}</div>}
                {currentKg.contacts?.email && <div><strong>Email:</strong> {currentKg.contacts.email}</div>}
                {currentKg.head?.firstName && <div><strong>Директор:</strong> {currentKg.head.firstName}</div>}
              </div>
            </div>

            {/* Образовательные и парциальные программы */}
            <div className="kg-programs-section">
              <h5>Освітні та парціальні програми</h5>
              {programs.length > 0 ? (
                <Table responsive className="programs-table">
                  <thead>
                    <tr>
                      <th>Назва файлу</th>
                      <th>Розмір</th>
                      <th>Тип</th>
                      <th>Дії</th>
                    </tr>
                  </thead>
                  <tbody>
                    {programs.map((program, index) => {
                      return program.files.map((file, index_file) => (
                        <tr key={`${index}_${index_file}`}>
                          <td>{program.name} {index_file + 1}</td>
                          <td>{formatFileSize(file.length)}</td>
                          <td>{program.type}</td>
                          <td>
                            <Button 
                              variant="outline-primary" 
                              size="sm"
                              onClick={() => handleDownloadProgram(program._id, file._id, file.name)}
                            >
                              Завантажити
                            </Button>
                           </td>
                         </tr>
                      ));
                    })}
                  </tbody>
                </Table>
              ) : (
                <div className="no-programs">Немає доступних програм</div>
              )}
            </div>
          </div>
        </Collapse>

        {/* Информация о карте киянина */}
        <div className="registration-info">
          {child.statusMR?.result ? 
            <span className="registration-text">Картка киянина підтверджена</span> :
            <span className="registration-text">Картка киянина непідтверджена</span>
          }
          <span className="certificate-date">
            {child.kyivCardVerifiedDate ? new Date(child.kyivCardVerifiedDate).toLocaleDateString('uk-UA') : '22.05.2024'}
          </span>
          <span className="dot-separator">•</span>
          {false && <a href="#" className="update-data-link">Оновити дані</a>}
        </div>

        {/* Табы с информацией */}
        <div className="child-card-body">
          <Nav variant="tabs">
            <Nav.Item>
              <Nav.Link 
                active={activeTab === 'history'} 
                onClick={() => setActiveTab('history')}
              >
                Історія
              </Nav.Link>
            </Nav.Item>
            <Nav.Item>
              <Nav.Link 
                active={activeTab === 'billing'} 
                onClick={() => setActiveTab('billing')}
              >
                Нарахування
              </Nav.Link>
            </Nav.Item>
            <Nav.Item>
              <Nav.Link 
                active={activeTab === 'attendance'} 
                onClick={() => setActiveTab('attendance')}
              >
                Відвідування
              </Nav.Link>
            </Nav.Item>
            <Nav.Item>
              <Nav.Link 
                active={activeTab === 'payments'} 
                onClick={() => setActiveTab('payments')}
              >
                Оплати
              </Nav.Link>
            </Nav.Item>
          </Nav>
          <div className="tab-content">
            {renderTabContent()}
          </div>
        </div>
      </Card.Body>

      {/* Футер карточки */}
      <div className={`child-card-footer ${!isInKindergarten ? 'child-card-footer-actions' : ''}`}>
        {!isInKindergarten ? (
          <>
            <Button variant="primary">Запис до школи</Button>
          </>
        ) : (
          <a href="#" className="btn btn-link" onClick={handleDownloadInvoice}>
            Завантажити рахунок для сплати послуг харчування
          </a>
        )}
      </div>
    </Card>
  );
};

export default CabinetChildrenCard;